var map = {
	"./en/admin.json": [
		48186,
		[
			8186
		]
	],
	"./en/auth.json": [
		15021,
		[
			5021
		]
	],
	"./en/common.json": [
		79802,
		[
			9802
		]
	],
	"./en/dashboard.json": [
		26061,
		[
			6061
		]
	],
	"./en/education.json": [
		38295,
		[
			8295
		]
	],
	"./en/forms.json": [
		17670,
		[
			7670
		]
	],
	"./en/governance.json": [
		53599,
		[
			3599
		]
	],
	"./en/legal.json": [
		5596,
		[
			5596
		]
	],
	"./en/marketplace.json": [
		84358,
		[
			4358
		]
	],
	"./en/networking.json": [
		55069,
		[
			5069
		]
	],
	"./en/notifications.json": [
		55357,
		[
			5357
		]
	],
	"./en/profile.json": [
		11432,
		[
			1432
		]
	],
	"./en/settings.json": [
		42974,
		[
			2974
		]
	],
	"./en/toast.json": [
		29762,
		[
			9762
		]
	],
	"./pt-BR/admin.json": [
		54988,
		[
			4988
		]
	],
	"./pt-BR/auth.json": [
		1879,
		[
			1879
		]
	],
	"./pt-BR/common.json": [
		9220,
		[
			9220
		]
	],
	"./pt-BR/dashboard.json": [
		51515,
		[
			1515
		]
	],
	"./pt-BR/education.json": [
		50601,
		[
			601
		]
	],
	"./pt-BR/forms.json": [
		50708,
		[
			708
		]
	],
	"./pt-BR/governance.json": [
		38661,
		[
			8661
		]
	],
	"./pt-BR/legal.json": [
		60054,
		[
			54
		]
	],
	"./pt-BR/marketplace.json": [
		28016,
		[
			8016
		]
	],
	"./pt-BR/networking.json": [
		96083,
		[
			6083
		]
	],
	"./pt-BR/notifications.json": [
		12583,
		[
			2583
		]
	],
	"./pt-BR/profile.json": [
		20706,
		[
			706
		]
	],
	"./pt-BR/settings.json": [
		22512,
		[
			2512
		]
	],
	"./pt-BR/toast.json": [
		68672,
		[
			8672
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 72096;
module.exports = webpackAsyncContext;